import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  ContinueButton,
  ContinueButton2,
  ContractInput,
  Footer,
  Header,
  Option,
  Question,
  RowOptions,
  SearchContainer,
  SearchIcon,
  Select,
  WrapContent,
  WrapContractInfo,
} from "../../styles/Particular";
import {
  errorContract,
  getClubs,
  getContractById,
  getContractInfo,
} from "../../data/services/crew_service";
import { FormInput } from "../../styles/PreRegister";
import { useNavigate } from "react-router-dom";
import { PFFORM } from "../../core/app-urls";

export default function Particular() {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [contractId, setContractId] = useState("");
  const [error, setError] = useState<String>("");
  const [contractData, setContractData] = useState<any>(null);
  const [clubs, setClubs] = useState<any[]>([]);
  const [selectedClubId, setSelectedClubId] = useState<string>("");
  const [contracts, setContracts] = useState<any[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchClubs() {
      const { clubs } = await getClubs();
      setClubs(clubs);
    }
    fetchClubs();
  }, []);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0]);
    }
  };

  return (
    <Container>
      <WrapContent>
        <Header>
          <h1>PORTAL DO CLIENTE</h1>
          <h3>Cadastro</h3>
        </Header>

        <Card>
          {/* <Question>Você é colaborador de uma empresa vinculada ao SESI?</Question>
          <RowOptions>
            <Option>
              <input
                type="radio"
                name="membership"
                value="SIM"
                checked={selectedOption === "SIM"}
                onChange={() => setSelectedOption("SIM")}
              />
              SIM
            </Option>
            <Option>
              <input
                type="radio"
                name="membership"
                value="NÃO"
                checked={selectedOption === "NÃO"}
                onChange={() => setSelectedOption("NÃO")}
              />
              NÃO
            </Option>
          </RowOptions> */}

          <Question>Você é Industriário?</Question>
          <h2>Caso você seja industriário tenha em mãos um documento de vínculo industrial.</h2>
          <RowOptions>
            <Option>
              <input
                type="radio"
                name="membership2"
                value="SIM"
                checked={selectedOption2 === "SIM"}
                onChange={() => setSelectedOption2("SIM")}
              />
              SIM
            </Option>
            <Option>
              <input
                type="radio"
                name="membership2"
                value="NÃO"
                checked={selectedOption2 === "NÃO"}
                onChange={() => setSelectedOption2("NÃO")}
              />
              NÃO
            </Option>
          </RowOptions>

          <p>Faça upload do documento que comprova vínculo industrial</p>
          <label htmlFor="file-upload">
            <input type="file" id="file-upload" accept="application/pdf" onChange={handleFileChange} />
          </label>
          {selectedFile && <p>Arquivo selecionado: {selectedFile.name}</p>}
          <ContinueButton onClick={() => navigate(PFFORM, { state: { privateForm: true } })}>
            Continuar
          </ContinueButton>
        </Card>

        <Footer>Developed by WBC SISTEMAS</Footer>
      </WrapContent>
    </Container>
  );
}
